# Photo gallery seeds
# In a real app, photos come from the camera
# This just ensures the database is ready
puts "Photo gallery ready - take some photos!"
